import { SpriteStates } from "./components/Sprite"

export enum ScaleStyle {
	Linear = "linear",
	Exponential = "exponential",
	Fibonacci = "fibonacci",
	Easing = "easing",
}

export interface ValuesConfig {
	scaleStyle: ScaleStyle
	exponent: {
		base: number
		power: number
	}
	easing: {
		fn: (x: number) => number
		reverse: boolean
	}
	scaleFactor: number
}

export interface IPlayer {
	name: string
	team: string
	seasonFinish?: number
	playoffFinish?: number
	consolation: boolean
	headStart: number
	time: number
	state: SpriteStates
	animationDuration?: number
	animationDelay?: number
}
